import { UeContainer } from '@oneaudi/falcon-tools';
import { NavigationBar } from '@oneaudi/unified-web-components';
import React, { useContext, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Context } from '../../../context/Context';
import { useI18n } from '../../../i18n';
import { attachHorizontalNavigation } from '../../../utils/a11y';
import { LeftContainer, RightContainer, StyledMainMenu } from '../SubPageNavigationStyles';
import CtaSection from '../ui/CtaSection';
import SubmenuTrigger from '../ui/SubmenuTrigger';

const CenterContainer = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
    display: block;
    min-width: 0;
  }
`;

/**
 * Yes this div seems unnecessary, but it is really needed.
 * If removed the NavigationBar component struggles to calculate it's correct size.
 * Only remove if you're 100% certain what you're doing.
 */
const NavigationBarWrapper = styled.div`
  width: 100%;
`;

const MainMenu: React.FC = () => {
  const {
    hasCta,
    content: { links },
  } = useContext(Context);
  const menuRef = useRef<HTMLElement>(null);
  const ariaLabel = useI18n('ariaMenu');
  const ariaScrollLeft = useI18n('ariaScrollLeft');
  const ariaScrollRight = useI18n('ariaScrollRight');

  useEffect(() => {
    if (menuRef.current) {
      attachHorizontalNavigation(menuRef.current);
    }
  }, []);

  return (
    <StyledMainMenu aria-label={ariaLabel} ref={menuRef}>
      <LeftContainer>
        <SubmenuTrigger />
      </LeftContainer>
      <CenterContainer>
        <NavigationBarWrapper>
          <UeContainer propertyPath="links" label="Sub Pages">
            <NavigationBar
              id="nav-bar__scrolling"
              scrollButtons={{
                left: { ariaLabel: ariaScrollLeft },
                right: { ariaLabel: ariaScrollRight },
              }}
              size="sm"
              items={links.map((link) => ({
                active: link.currentPage === true,
                label: link.text,
                href: link.href,
              }))}
              className="subpage-navigation-bar"
            />
          </UeContainer>
        </NavigationBarWrapper>
      </CenterContainer>
      {hasCta && (
        <RightContainer>
          <CtaSection />
        </RightContainer>
      )}
    </StyledMainMenu>
  );
};

export default MainMenu;
